import { FC, useState } from 'react';
import EToast from '@/components/everridge/EToast';
import CopyIcon from '@/components/icons/CopyIcon';
import TickIcon from '@/components/icons/TickIcon';

type Props = {
	label: string;
	value: string;
	icon: React.FC<React.SVGProps<SVGSVGElement>>;
	unit?: string;
};

const ApartmentsDetailsBasicElement: FC<Props> = ({
	label,
	value,
	icon: IconComponent,
	unit,
}) => {
	const [copied, setCopied] = useState<boolean>(false);

	const copyElementHandler = () => {
		navigator.clipboard.writeText(value);
		setCopied(true);
		setTimeout(() => setCopied(false), 500);
		EToast({
			variant: 'success',
			message: 'Copied to clipboard',
			description: `${label} copied to clipboard.`,
		});
	};

	return (
		<div
			className='p-3 rounded-semi-xl flex justify-between text-sm select-none cursor-pointer transition-all ease-in-out duration-300 hover:bg-popover-50'
			onClick={copyElementHandler}>
			<div className='flex items-center gap-2.5'>
				<IconComponent className='stroke-popover-1000' />
				<span>{label}</span>
			</div>
			<div className='flex gap-2.5'>
				<span>{`${value} ${unit ?? ''}`}</span>
				<div className='relative size-5'>
					<CopyIcon
						className={`absolute transition-all duration-300 ${
							copied ? 'opacity-0' : 'opacity-100'
						}`}
					/>
					<TickIcon
						className={`absolute transition-all duration-300 ${
							copied ? 'opacity-100' : 'opacity-0'
						}`}
					/>
				</div>
			</div>
		</div>
	);
};

export default ApartmentsDetailsBasicElement;
